import ApplicationModel, { attr } from '../ApplicationModel';
import { type IdeaThemeIdeaAttributes } from './generated/IdeaThemeIdeaAttributes';
import { model } from '../modelBuilder';

interface IdeaThemeIdea extends IdeaThemeIdeaAttributes {}

@model
class IdeaThemeIdea extends ApplicationModel {
  // Start auto-generated
  static typename: 'IdeaThemeIdea' = 'IdeaThemeIdea';
  get typename(): 'IdeaThemeIdea' {
    return 'IdeaThemeIdea';
  }

  static internalTypename: 'Ideas::IdeaThemeIdea' = 'Ideas::IdeaThemeIdea';
  get internalTypename(): 'Ideas::IdeaThemeIdea' {
    return 'Ideas::IdeaThemeIdea';
  }

  static inputType = 'IdeaThemeAttributes!';

  static fields = {
    id: attr({ readable: true }),
    ideaId: attr({ readable: true }),
    ideaThemeId: attr({ readable: true }),
    name: attr({ writable: true, readable: false }),
    idea: attr.belongsTo({ readable: true, typename: 'Idea' }),
    ideaTheme: attr.belongsTo({ readable: true, typename: 'IdeaTheme' }),
    project: attr.belongsTo({ writeShape: ['id'], readable: false }),
    bookmarksRecordPositions: attr.hasMany({
      args: { filters: 'RecordPositionFilters' },
      readable: true,
    }),
  };
  // End auto-generated
}

export default IdeaThemeIdea;
